import { useContext, useMemo } from "react";
import axios from "axios";
import { authContext } from "./useAuth";
import { BotContext } from "../../components/context";
import { userRefresh } from "../services";
import { useHistory } from "react-router-dom";

const WithAxios = ({ children }) => {
  const { logTokenOut, signout } = useContext(authContext);
  const { tokenUser } = useContext(BotContext);
  const CHANNEL = "mobile";
  const { staticToken } = JSON.parse(sessionStorage.getItem("config")) || {};
  const { customer } = JSON.parse(sessionStorage.getItem("customer")) || {};
  const history = useHistory();
  useMemo(() => {
    axios.interceptors.request.use(function(config) {
      config.headers["Pragma"] = "no-cache";
      config.headers["channel"] = CHANNEL;
      config.headers["Access-Control-Allow-Origin"] = "*";
      const user = JSON.parse(localStorage.getItem("userinfo"));
      if (process.env.REACT_APP_LOGIN === "true") {
        config.headers["Authorization"] = `Bearer ${user?.accessToken}`;
      } else {
        config.headers["Authorization"] = `Bearer ${staticToken}`;
      }
      return config;
    });
    axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        // throw error;
        switch (error?.response?.status) {
          case 401:
            if (process.env.REACT_APP_LOGIN === "true") {
              const userinfo = JSON.parse(localStorage.getItem("userinfo"));
              if(process.env.REACT_APP_PROJECT === "widget" && !userinfo?.refreshToken){
                window.parent.postMessage(
                  {
                    func: "refreshSessionInit",
                  },
                  "*"
                );
              }else{
                if (userinfo?.refreshToken) {
                  userRefresh()
                    .then((rs) => {
                      const { accessToken } = rs?.data?.data;
                      const userInfo = { ...userinfo, accessToken };
                      localStorage.setItem("userinfo", JSON.stringify(userInfo));
                    })
                    .catch(() => {
                      signout(history);
                    });
                } else {
                  signout(history);
                }
              }
            
            }
            return Promise.reject("خطای احراز هویت");
          case 404:
            return Promise.reject("درخواست یافت نشد");

          default:
            return Promise.reject("خطا در برقراری ارتباط");
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logTokenOut, tokenUser]);

  return children;
};

export default WithAxios;
